import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from '../styles/components/_Billetterie.module.scss';
import { useCustomNavigation } from './NavigationContext';

const Billetterie = () => {
 const navigate = useNavigate();
   const { customNavigate } = useCustomNavigation();

 return (
   <div className={styles.billetterie}>
     <h3 className={styles.billetterie__title}>Billetterie</h3>
     <p className={styles.billetterie__text}>
       Ne manque pas l'occasion de participer au Poney Club Festival. Choisis ton pass et profite de notre soirée exceptionnelle.
     </p>
     <button 
       onClick={() => customNavigate('/billetterie')}
       className="custom-button custom-button--light"
     >
       Accéder à la Billetterie
     </button>
   </div>
 );
};

export default Billetterie;